import sydneySkyline from "./assets/sydney-skyline.png";

export const servicesTrustHeroSkylineTokens = {
  sydney: {
    src: sydneySkyline,
    alt: "Sydney skyline illustration",
  },
} as const;

export type ServicesTrustHeroSkylineToken = keyof typeof servicesTrustHeroSkylineTokens;

export const servicesTrustHeroTokens = {
  colors: {
    background: "#f6f8fb",
    surface: "#ffffff",
    text: "#07142f",
    textSoft: "#243452",
    textMuted: "#5b6678",
    accent: "#ed1c24",
    accentDark: "#c80f17",
    border: "rgba(7, 20, 47, 0.1)",
    borderStrong: "rgba(7, 20, 47, 0.18)",
    shadow: "0 18px 48px rgba(7, 20, 47, 0.09)",
    softShadow: "0 10px 28px rgba(7, 20, 47, 0.07)",
    gold: "#ffb300",
    blue: "#1a73e8",
  },
  radius: {
    shell: 8,
    card: 8,
    pill: 8,
    button: 8,
  },
  sizes: {
    maxWidth: 1180,
  },
  defaults: {
    skyline: "sydney" as ServicesTrustHeroSkylineToken,
    badgeLabel: "Proudly servicing Sydney",
    badgeText: "Sydney homes, businesses & strata",
    title: "Trusted Sydney Pest Control",
    titleHighlight: "Pest Control",
    lead: "Friendly experts. Fast response. Clear advice.",
    description:
      "We deliver effective pest control with a friendly approach, clear communication, and tailored solutions for homes, businesses, and strata across Sydney.",
    benefits: [
      "Local Sydney team you can rely on",
      "Safe, effective treatments for every property",
      "Honest advice with no upselling",
    ],
    primaryAction: {
      label: "Call or Message Us",
      href: "#contact",
      icon: "contact",
    },
    secondaryAction: {
      label: "View Full Range of Services",
      href: "#services",
      icon: "services",
    },
    review: {
      rating: "4.9",
      reviewCountText: "Google rating from 250+ reviews",
      ctaLabel: "Read Google Reviews",
      href: "#reviews",
    },
    trustItems: [
      {
        icon: "shield",
        title: "Licensed & Insured",
      },
      {
        icon: "clock",
        title: "Fast Response",
        text: "Same-day available",
      },
      {
        icon: "building",
        title: "Homes, Businesses & Strata",
      },
      {
        icon: "smile",
        title: "Friendly Local Support",
      },
    ],
  },
} as const;
